import { Component, OnInit } from '@angular/core';
import { AdministrationResultStatus, PaginationArgs, TermData } from 'src/app/clients/system-api/SystemApiClient';
import { TermService } from 'src/app/services/term.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  todayTermData: TermData[]  = [];
  termData: TermData[] | undefined = [];
  currentDate = new Date();

  constructor(
    private termService: TermService,) { 
    }

  ngOnInit(): void {
    var paginationArgs = new PaginationArgs();
    paginationArgs.skipCount = 0;
    paginationArgs.maxResultCount = 9999;
    paginationArgs.sorting = 'Id ASC';
    paginationArgs.active = true;

    this.termService.retrieveAllTerms(paginationArgs).subscribe(next => {
      if(next.status == AdministrationResultStatus.Success) {
        if(next.content != null && next.content.items != null && next.content.items.length > 0) {
          this.termData = next.content!.items;
          this.todayTermData = this.termData?.filter(x=>x.fromDate?.getDate() == this.currentDate.getDate())
    
          const events = this.termData?.map(term => ({
            title: term.serviceName?.toString(),
            date: this.formatDate(term.fromDate),
            end: this.formatDate(term.toDate)
          }));
        } else {
          this.todayTermData = [];
        }
      }
    })
  }

  formatDate(date: string | Date | undefined): string | undefined {
    if (!date) {
      return undefined;
    }

    const formattedDate = new Date(date).toISOString();
  
    return formattedDate;
  }

  calculateTotalMinutesDifference(term: TermData): number {
    const startTime = term.fromDate!.getTime();
    const endTime = term.toDate!.getTime();

    const timeDifference = endTime - startTime;

    const totalMinutes = Math.floor(timeDifference / (1000 * 60));

    return totalMinutes;
  }
}


